import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from '../../../services/token.service';
import { Meta } from '@angular/platform-browser';
import { DISCORD_URL } from '../../../services/constants';

@Component({
	selector: 'community',
	templateUrl: 'community.html',
	styleUrls: ['community.scss']
})
export class CommunityComponent implements OnInit {

	constructor(
		private _tokenService: TokenService,
		private _router: Router,
		private _meta: Meta
	) {
		this._meta.updateTag({ name: 'description',
			content: 'CropManage is a crop management web application developed ' +
			'by UCANR which help farmers manage irrigation and fertilization scheduling.'})
	}

	ngOnInit(): void {
	}

	openDiscordLink(): void {
		window.open(DISCORD_URL, '_blank');
	}
}
